module.exports = __webpack_public_path__ + "img/legalServices-2.c9aa863e.png";